import React from 'react';
import streaming from '../../../pics/icons/streaming.gif';

function FolderList({ folders, onEncounterClick, streamingEncounter, adminView, clickEncounterDropdownMenuX = undefined, currentEncounter, setCurrentEncounter, depth = 0, collapsedFolders, setCollapsedFolders}) {
    // Sort folders so "No Folder" is always last
    const sortedEntries = Object.entries(folders).sort(([a], [b]) => {
        if (a === "No Folder") return 1;
        if (b === "No Folder") return -1;
        return a.localeCompare(b);
    });

    return sortedEntries.map(([folder, data]) => {
        const folderKey = `${depth}-${folder}`;
        const isCollapsed = collapsedFolders[folderKey];

        return (
            <React.Fragment key={folder}>
                <li
                    className="dropdown-folder-title"
                    style={{
                        fontWeight: 700,
                        fontSize: depth === 0 ? "1.08rem" : "1rem",
                        color: folder === "No Folder" ? "#333" : (depth === 0 ? "#3d1e00" : "#822000"),
                        background: folder === "No Folder"
                            ? "#b7b7b7"
                            : (depth === 0 ? "#ffe9c7" : "#f2f2e2"),
                        padding: depth === 0 ? "8px 12px 8px 2px" : "6px 10px 6px 2px",
                        borderBottom: "1px solid #e0d6c3",
                        listStyle: "none",
                        letterSpacing: folder === "No Folder" ? "1px" : (depth === 0 ? "0.5px" : undefined),
                        borderLeft: folder === "No Folder"
                            ? "4px solid #822000"
                            : "4px solid #c7a97a",
                        boxShadow: folder === "No Folder" ? "0 2px 8px #0001" : undefined,
                        display: "flex",
                        alignItems: "center",
                        cursor: Object.keys(data.__children).length > 0 || data.__encounters.length > 0 ? "pointer" : "default",
                    }}
                    onClick={e => {
                        if(folder !== "No Folder") {
                            e.stopPropagation();
                            setCollapsedFolders(prev => ({
                                ...prev,
                                [folderKey]: !isCollapsed
                            }));
                        }
                    }}
                >
                    {/* Folder collapse/expand icon */}
                    {(Object.keys(data.__children).length > 0 || data.__encounters.length > 0) && (
                        <>
                            {folder !== "No Folder" && 
                                <span
                                    style={{
                                        marginRight: 8,
                                        userSelect: "none",
                                        fontSize: "1.1em",
                                        cursor: "pointer",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        width: 16,
                                        height: 16
                                    }}
                                >
                                    <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 14 14"
                                        style={{
                                            display: "block",
                                            transform: isCollapsed ? "rotate(0deg)" : "rotate(90deg)",
                                            transition: "transform 0.15s"
                                        }}
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <polyline
                                            points="4,3 9,7 4,11"
                                            fill="none"
                                            stroke="#822000"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </span>
                            }
                        </>
                    )}
                    {folder}
                </li>
                {!isCollapsed && (
                    <>
                        {data.__encounters.map((encounter, index) => (
                            <li
                                key={encounter.encounterGuid || encounter.encounterName + index}
                                onClick={() => onEncounterClick(encounter)}
                                className="dropdown-item"
                                style={{
                                    paddingLeft: "12px",
                                    borderLeft: folder === "No Folder" ? '4px solid #822000' : "4px solid #c7a97a",
                                    background: "white"
                                }}
                            >
                                {encounter.encounterName === currentEncounter.encounterName 
                                    ? <b>{'--'} {encounter.encounterName}</b> 
                                    : <>{encounter.encounterName || <i style={{fontSize: 'small'}}>No Title</i> }</>
                                }
                                
                                {encounter.encounterGuid === streamingEncounter?.encounterGuid && 
                                    <img alt='streaming' className='streamingGif' src={streaming} />
                                }
                                {adminView && <strong>{encounter.username}</strong>}
                                {((!adminView || encounter.username === 'Username') && clickEncounterDropdownMenuX) && 
                                    <button className='encounterDropdownX' onClick={(event) => clickEncounterDropdownMenuX(event, encounter)}>
                                        ❌
                                    </button>
                                }
                            </li>
                        ))}
                        {/* Recursively render subfolders */}
                        {Object.keys(data.__children).length > 0 && (
                            <ul style={{paddingLeft: 10, background: "rgb(199, 169, 122)"}}>
                                <FolderList
                                    folders={data.__children}
                                    onEncounterClick={onEncounterClick}
                                    streamingEncounter={streamingEncounter}
                                    adminView={adminView}
                                    clickEncounterDropdownMenuX={clickEncounterDropdownMenuX}
                                    currentEncounter={currentEncounter}
                                    setCurrentEncounter={setCurrentEncounter}
                                    depth={depth + 1}
                                    collapsedFolders={collapsedFolders}
                                    setCollapsedFolders={setCollapsedFolders}
                                />
                            </ul>
                        )}
                    </>
                )}
            </React.Fragment>
        );
    });
}

export default FolderList;